module.exports = __webpack_public_path__ + "media/images/aloe/illustrations/error2-fdc1709748754e488bf483adac8ca860.svg";